import { dataTransferWrap } from './../dataTransferService';
import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getPositionsMachines(companyId) {
    return dataTransferWrap(
        ModulesMap.POSITIONS_MACHINES,dtConfig[ModulesMap.POSITIONS_MACHINES].getPositionsMachines,
        {
            urlParams: {
                companyId
            },
        }
    )
}

function getPositionsMachine(companyId, machineId) {
    return dataTransferWrap(
        ModulesMap.POSITIONS_MACHINES,dtConfig[ModulesMap.POSITIONS_MACHINES].getPositionsMachine,
        {
            urlParams: {
                companyId,
                machineId
            }
        }
    )
}

function getPositionsMachineOnTimePoint(companyId, machineId, query) {
    return dataTransferWrap(
        ModulesMap.POSITIONS_MACHINES,dtConfig[ModulesMap.POSITIONS_MACHINES].getPositionsMachineOnTimePoint,
        {
            urlParams: {
                companyId,
                machineId
            },
            params: query
        }
    )
}

export default {
    getPositionsMachines,
    getPositionsMachine,
    getPositionsMachineOnTimePoint,
}